var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 13.3333C26.6667 5.97333 20.6933 0 13.3333 0C5.97333 0 0 5.97333 0 13.3333C0 19.7867 4.58667 25.16 10.6667 26.4V17.3333H8V13.3333H10.6667V10C10.6667 7.42667 12.76 5.33333 15.3333 5.33333H18.6667V9.33333H16C15.2667 9.33333 14.6667 9.93333 14.6667 10.6667V13.3333H18.6667V17.3333H14.6667V26.6C21.4 25.9333 26.6667 20.2533 26.6667 13.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFace);
export default __webpack_public_path__ + "static/media/ic_face.5c6d47f4795cf59548bfe5c7181f64f4.svg";
export { ForwardRef as ReactComponent };